import { render, staticRenderFns } from "./form-bmi.vue?vue&type=template&id=561ed0d3&scoped=true"
import script from "./form-bmi.vue?vue&type=script&lang=js"
export * from "./form-bmi.vue?vue&type=script&lang=js"
import style0 from "./form-bmi.vue?vue&type=style&index=0&id=561ed0d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561ed0d3",
  null
  
)

export default component.exports